import React, { useEffect, useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import AudiencePaths from "../components/AudiencePaths";
import HowItWorks from "../components/HowItWorks";
import Outsourcing from "../components/Outsourcing";
import ChooseUs from "../components/ChooseUs";
import Industries from "../components/Industries";
import Impact from "../components/Impact";
import ProofOutcomes from "../components/ProofOutcomes";
import Footer from "../components/Footer";
import ServicesUpdate from "../components/ServicesUpdate";
import ContactUs from "../components/ContactUS/ContactUs";

const DEFAULT_SECTION_OFFSET = 90;

export default function MainScreen() {
  const location = useLocation();
  const navigate = useNavigate();

  // Deep-link from other routes (e.g. About page): land on section before paint (avoids nav spy flicker).
  useLayoutEffect(() => {
    const target = location.state?.scrollTo;
    if (!target || typeof target !== "string") return;
    const offset =
      Number(location.state?.scrollOffset ?? DEFAULT_SECTION_OFFSET) ||
      DEFAULT_SECTION_OFFSET;
    const el = document.getElementById(target);
    if (el) {
      window.scrollTo({
        top: Math.max(0, el.offsetTop - offset),
        behavior: "auto",
      });
    }
    navigate(`${location.pathname}${location.search}`, {
      replace: true,
      state: {},
    });
  }, [location.state, location.pathname, location.search, navigate]);

  // URL hash e.g. /#our__services
  useEffect(() => {
    const hash = (location.hash || "").replace(/^#/, "");
    if (!hash) return;
    const id = window.requestAnimationFrame(() => {
      const el = document.getElementById(hash);
      if (el) {
        window.scrollTo({
          top: Math.max(0, el.offsetTop - DEFAULT_SECTION_OFFSET),
          behavior: "auto",
        });
      }
    });
    return () => window.cancelAnimationFrame(id);
  }, [location.pathname, location.hash]);

  return (
    <div>
      <Navbar />
      <Header />
      <AudiencePaths />
      <HowItWorks />
      <ServicesUpdate />
      <Industries />
      <ChooseUs />
      <Outsourcing />
      <Impact />
      <ProofOutcomes />
      <ContactUs />
      <Footer />
    </div>
  );
}
